"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isomorphic_logger_1 = __importDefault(require("@spotify-internal/isomorphic-logger"));
class ConsoleReporter {
    constructor(spacingLevel = 2, logLevel = 'info') {
        this.spacingLevel = spacingLevel;
        this.logLevel = logLevel;
    }
    send(metrics) {
        return __awaiter(this, void 0, void 0, function* () {
            isomorphic_logger_1.default.log(this.logLevel, `[semantic-metrics] ${JSON.stringify(metrics, null, this.spacingLevel)}`);
        });
    }
}
exports.ConsoleReporter = ConsoleReporter;
//# sourceMappingURL=Console.js.map